// extracted by mini-css-extract-plugin
export default {"adminContainer":"AdminPanel_adminContainer__qbGeI"};